module.exports = __webpack_public_path__ + "img/2_pc.1acdbe8b.gif";